export default "/images/vendor/flag-icon-css/flags/1x1/it.svg?febcc1b18059405d2a1b169a335888f5";